var map = {
	"./WhatsApp Image 2024-12-02 at 09.56.11 (1).jpeg": 2636,
	"./WhatsApp Image 2024-12-02 at 09.56.11 (2).jpeg": 8395,
	"./WhatsApp Image 2024-12-02 at 09.56.11.jpeg": 5746,
	"./WhatsApp Image 2024-12-02 at 09.56.12 (1).jpeg": 4517,
	"./WhatsApp Image 2024-12-02 at 09.56.12 (2).jpeg": 4554,
	"./WhatsApp Image 2024-12-02 at 09.56.12.jpeg": 3039,
	"./WhatsApp Image 2024-12-02 at 09.56.13 (1).jpeg": 658,
	"./WhatsApp Image 2024-12-02 at 09.56.13 (2).jpeg": 2829,
	"./WhatsApp Image 2024-12-02 at 09.56.13.jpeg": 2520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6677;